import React from 'react';
import Tissue from '../assets/img/Tissue.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function TissueCellProcessing() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content"  >
                                    <div className="section-heading marginbot20">
                                        <p className='mb-0'><strong>Tissue </strong> Cell Processing </p><h5></h5><p className='mb-3'></p>
                                    </div>
                                    <img src={Tissue} className="alignleft" alt="" style={{height:"200px", width:"200px"}}  />
                                    <p className='mb-3'>
                                        CytoCare offers a full range of high end technology for cell or tissue processing.<br /> Our technology provide our clinicians and healthcare organizations with economic alternatives for collection, processing, and storage of various kind of human cells.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default TissueCellProcessing;
